const getPathWithGetParams = (url: string, params: Record<string, string | number>): string => {
  if (Object.keys(params).length === 0) {
    return url;
  }

  let queryString = '';
  Object.entries(params).forEach(([key, value]) => {
    queryString += `${key}=${value}&`;
  });

  queryString = queryString.slice(0, -1);
  return url.indexOf('?') !== -1 ? `${url}&${queryString}` : `${url}?${queryString}`;
};

export default getPathWithGetParams;
